//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
/** Components */
import NOT_BASIC_01 from './NOT_BASIC_01';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSearch1 } from './NOT_BASIC_01_QUERY';
//#endregion

function NOT_BASIC_01F(props) {
  //#region 변수
  const navigate = useNavigate();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    index: 0,
    actions: <></>,
  });
  const [rowData, setRowData] = useState([]); //그리드 데이터
  const [selectedRowData, setSelectedRowData] = useState([]); //그리드 안 체크된 데이터
  const [changedRowData, setChangedRowData] = useState([]); //그리드 변경된 데이터
  const gridRef1 = useRef(); //그리드

  //#endregion

  //#region 쿼리
  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData(rows);
    },
  });
  //#endregion

  return (
    <div className="wrap">
      <NOT_BASIC_01
        gridId1={'grid1'}
        gridRef1={gridRef1}
        userInfo={userInfo}
        lanInfo={lanInfo}
        rowData={rowData}
        setRowData={setRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        navigate={navigate}
        Search1={Search1}
        dialog={dialog}
        setDialog={setDialog}
      />
    </div>
  );
}

export default NOT_BASIC_01F;
